<template>
  <!-- 侧边栏 -->
  <div id="layout-header" class="group testheader">
    <div id="header">
      <div class="zone zone-header">
        <div class="widget-header widget-rccl-nav-widget widget">
          <div
            class="panel-overlay"
            :style="checkPanelOverlayOpen()"
            @click="closePanel()"
          ></div>
          <div
            class="panel panel-left panel-reveal theme-dark panel-left"
            id="panel-left"
            :style="checkPanelOpen()"
          >
            <div class="content-block home_content_block pad_0 mt10">
              <div class="home_tlineb333 border-botom-none leftMenu-close">
                <a class="close-panel" @click="closePanel()">
                  <img
                    src="https://mobile.rcclchina.com.cn/Themes/RcclMobileTheme/Images/homeImg/leftalllow.png"
                    alt=""
                  />
                </a>
                <img
                  class="logo_tag"
                  src="https://mobile.rcclchina.com.cn/Themes/RcclMobileTheme/Images/homeImg/logo_tag.png"
                  alt=""
                />
              </div>

              <nav-image
                v-if="navImage"
                :imageUrl="navImage.imageUrl"
                :link="navImage.link"
              />

              <div class="login_prev" v-if="!isLogin">
                <img
                  class="login_per"
                  src="https://mobile.rcclchina.com.cn/Themes/RcclMobileTheme/Images/homeImg/mb-per.png"
                  alt=""
                />
                <a
                  @click="
                    onLinkClick(
                      '/Orchard.Rccl.Users/Login/Login?returnUrl=' +
                        encodeURIComponent(locationHref)
                    )
                  "
                  >登录/注册</a
                >
              </div>

              <div class="login_after" v-if="isLogin">
                <div class="login_nikeName">
                  <img class="tag" :src="userIcon" alt="" />
                  <span class="username">{{ userName }}</span>
                  <span
                    v-if="userInfo.levelEN && userInfo.levelEN.length > 0"
                    class="grade"
                    :style="getUserRewardTitle(userInfo.levelEN)"
                  ></span>

                  <a
                    class="per-center external"
                    href="/Rccl.UserCenter/CustomerInfo/Info"
                  >
                    <span>个人中心</span>
                    <img
                      src="https://mobile.rcclchina.com.cn/Themes/RcclMobileTheme/Images/homeImg/mb-leftarrow.png"
                      alt=""
                    />
                  </a>
                </div>
                <ul class="classify">
                  <li
                    onclick="window.location.href='/Rccl.UserCenter/OrderRecord/List'"
                  >
                    <div class="login-icon icon-order">
                      <img
                        src="https://resource.rcclchina.com.cn/Home/new/user/myOrder.png"
                        alt=""
                        style="width: 25px"
                      />
                    </div>
                    <div class="txt">我的订单</div>
                  </li>
                  <li
                    onclick="window.location.href='/Rccl.UserCenter/UserCoupon/UserCoupon?isExpired=1'"
                  >
                    <div class="login-icon icon-coupon">
                      <img
                        src="https://resource.rcclchina.com.cn/Home/new/user/coupon.png"
                        alt=""
                        style="width: 34px"
                      />
                    </div>
                    <div class="txt">优惠券</div>
                  </li>

                  <li
                    onclick="window.location.href='/Rccl.RewardPoint/RewardPoints/myGift'"
                  >
                    <div class="login-icon icon-gift">
                      <img
                        src="https://resource.rcclchina.com.cn/Home/new/user/gift.png"
                        alt=""
                        style="width: 33px"
                      />
                    </div>
                    <div class="txt">礼品券</div>
                  </li>
                </ul>
              </div>

              <div class="home_second_nav">
                <div v-for="(nav, i) in navItems" :key="i">
                  <div
                    class="home_tlineb333 home_second_nav_item home_jhlx border-botom-none"
                    @click="changeCurrentItemIndex(i)"
                  >
                    <div>
                      <img class="nav-img nav1-2" :src="nav.icon" />
                      {{ nav.title }}
                    </div>
                    <div
                      class="jia jia0 menu-arrowIcon abs"
                      :class="{ hidden: i == currentItemIndex }"
                    >
                      <img
                        src="https://mobile.rcclchina.com.cn/Themes/RcclMobileTheme/Images/homeImg/alllow_down.png"
                      />
                    </div>
                    <div
                      class="jian jian0 menu-arrowIcon abs"
                      :class="{ hidden: !(i == currentItemIndex) }"
                    >
                      <img
                        src="https://mobile.rcclchina.com.cn/Themes/RcclMobileTheme/Images/homeImg/allow_up.png"
                      />
                    </div>
                  </div>
                  <ul
                    class="home_hxcxt jhlx full_pdmg"
                    :class="{ hidden: !(i == currentItemIndex) }"
                  >
                    <li
                      v-for="(subItem, j) in getNavSubItems(nav.navSubItems)"
                      :key="j"
                      class="home_mgl2r border-botom-none"
                    >
                      <a
                        :rel="getLinkRef(subItem.link)"
                        :href="subItem.link"
                        @click="gioTracking(i+1, j+1, subItem.link)"
                        class="close-panel external menu-alink"
                        >{{ subItem.title }}</a
                      >
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const NavImage = () => import("@/components/Home/NavImage");
import { gioTracking } from '@/utilities/tools'
// import _ from 'lodash'
export default {
  name: "BaseNav",
  components: {
    NavImage,
  },
  asyncData({ store }) {
    return new Promise((resolve, reject) => {
      return store
        .dispatch("GET_NAV_ITEMS")
        .then(() => {
          resolve();
        })
        .catch((e) => {
          reject(e);
        });
    });
  },
  data() {
    return {
      currentItemIndex: -1,
    };
  },
  beforeMount() {
    const userInfo = this.$store.state.user.userInfo;
    const userToken = this.$store.state.user.userToken;
    if (
      (!userInfo || !userInfo.fullName) &&
      userToken &&
      userToken.length > 0
    ) {
      this.$store.dispatch("GET_USER_INFO", userToken);
    }
  },
  methods: {
    checkPanelOpen() {
      return this.$store.state.page.openPanel
        ? { width: "330px" }
        : { width: "0px" };
    },
    checkPanelOverlayOpen() {
      return this.$store.state.page.openPanel
        ? { display: "block" }
        : { display: "none" };
    },
    closePanel() {
      this.$store.dispatch("SET_NAV_PANEL", false);
    },
    getNavSubItems(items) {
      return items.filter((item) => item.showMobile && item.title);
    },
    getLinkRef(link) {
      let linkRel = "";
      if (
        link.indexOf("rclrow.com") >= 0 ||
        link.indexOf("rclolci.com") >= 0 ||
        link.indexOf("pcprcl.com") >= 0
      ) {
        linkRel = "nofollow";
      }
      return linkRel;
    },
    changeCurrentItemIndex(index) {
      this.currentItemIndex = this.currentItemIndex == index ? -1 : index;
    },
    getUserRewardTitle(level) {
      let userTag = "";
      if (level) {
        switch (level) {
          case "T1": {
            userTag =
              "https://resource.rcclchina.com.cn/MobileMemberClub/lv1_text.png";
            break;
          }
          case "T2": {
            userTag =
              "https://resource.rcclchina.com.cn/MobileMemberClub/lv2_text.png";
            break;
          }
          case "T3": {
            userTag =
              "https://resource.rcclchina.com.cn/MobileMemberClub/lv3_text.png";
            break;
          }
          case "T4": {
            userTag =
              "https://resource.rcclchina.com.cn/MobileMemberClub/lv4_text.png";
            break;
          }
          default:
            break;
        }
      }
      if (userTag && userTag.length > 0) {
        return { "background-image": `url('${userTag}')` };
      } else {
        return { "background-image": `` };
      }
    },
    onLinkClick(link) {
      this.$store.dispatch("SET_NAV_PANEL", false);
      if (this.$router.currentRoute.path != link) {
        this.$router.push(link);
      }
    },
    gioTracking (menu, subMenu, desUrl) {
      gioTracking('track', 'evt_MainMenu', {
        menu,
        subMenu,
        desUrl
      })
      this.closePanel();
    }

  },
  computed: {
    navItems() {
      return this.$store.state.page.navItems.filter(
        (item) => item.showMobile && item.title
      );
    },
    navImage() {
      return this.$store.state.page.navImage || {};
    },
    userInfo() {
      return this.$store.state.user.userInfo;
    },
    isLogin() {
      const userInfo = this.$store.state.user.userInfo;
      return userInfo && userInfo.cmsId && userInfo.cmsId > 0;
    },
    userName() {
      if (
        this.userInfo &&
        this.userInfo.fullName &&
        this.userInfo.fullName.length > 0
      )
        return this.userInfo.fullName;
      return this.userInfo.mobile;
    },
    userIcon() {
      const userInfo = this.$store.state.user.userInfo;
      let userIcon =
        "https://resource.rcclchina.com.cn/logo/MB/logoAvatarCircleBlueLarge.png";

      if (userInfo && userInfo.levelEN) {
        switch (userInfo.levelEN) {
          case "T0": {
            userIcon = "";
            break;
          }
          case "T1": {
            userIcon =
              "https://resource.rcclchina.com.cn/MobileMemberClub/lv1.png";
            break;
          }
          case "T2": {
            userIcon =
              "https://resource.rcclchina.com.cn/MobileMemberClub/lv2.png";
            break;
          }
          case "T3": {
            userIcon =
              "https://resource.rcclchina.com.cn/MobileMemberClub/lv3.png";
            break;
          }
          case "T4": {
            userIcon =
              "https://resource.rcclchina.com.cn/MobileMemberClub/lv4.png";
            break;
          }
          default:
            break;
        }
      }
      return userIcon;
    },
    locationHref() {
      return location.href;
    },
  },
};
</script>

<style scoped>
#panel-left {
  display: block;
  z-index: 100000;
  transition: 0.2s;
  position: fixed;
}

div.panel-overlay {
  position: fixed;
  opacity: 1;
  background-color: rgba(0, 0, 0, 0.5);
}
</style>
